export default __webpack_public_path__ + "static/media/Malibu Outfitters.088f3297.jpg";